import { frameDebounce } from '@utilities/throttle';

const defaults = {
  isContentOver: false,
};

export default class PkAdaptiveCardsPlugin {
  opt: typeof defaults;
  dom: HTMLElement;

  constructor(dom: HTMLElement, options: typeof defaults) {
    this.opt = {
      ...defaults,
      ...options,
    };
    this.dom = dom;
  }

  init() {
    this.setCards();

    window.addEventListener('resize', this.setCards);
    window.addEventListener('orientationchange', this.setCards);
  }

  detach() {
    window.removeEventListener('resize', this.setCards);
    window.removeEventListener('orientationchange', this.setCards);
  }

  setCards = frameDebounce(() => {
    const isMobile = screen.availWidth < 768;
    return Array.from(this.dom.querySelectorAll<HTMLPkCardElement>('pk-card')).map((card) => {
      card.orientation = isMobile ? 'portrait' : 'horizontal';
      card.content = isMobile && this.opt.isContentOver ? 'over' : 'default';
      if (isMobile && this.opt.isContentOver) card.setAttribute('pk-theme', 'dark');
      else card.setAttribute('pk-theme', 'light');
    });
  });
}
